import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
import { Config } from './entities/various';

@Injectable()
export class AppConfig {
    static settings: Config;
    constructor(private http: HttpClient) {}
    load() {
        //const jsonFile = `assets/_conf/config.${environment.name}.json`;
        const jsonFile = `${environment.configpath}config.${environment.name}.json`;
        return new Promise<void>((resolve, reject) => {
            this.http.get(jsonFile).toPromise().then((response : any) => {
               AppConfig.settings = <Config>response;
               resolve();
            }).catch((response: any) => {
               reject(`Could not load file '${jsonFile}': ${JSON.stringify(response)}`);
            });
        });
    }
}
 